import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import TiposDeProductoConstant from 'constants/tiposDeProducto'

const TipoDeProductosFormGroup = ({ iValue, fIsSubmitting, dispatch, handleChange, setFieldValue }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)
      dispatch({ type: 'limpiar' })
      setFieldValue('codigoDetraccion', '')
    },
    [dispatch, handleChange, setFieldValue]
  )

  return (
    <Row>
      <Col md={3} xl={2}>
        <Field name='tipoProducto'>
          {({ field }) => (
            <Form.Radio
              {...field}
              onChange={onChange}
              disabled={fIsSubmitting}
              checked={iValue === TiposDeProductoConstant.BIEN}
              id='radio-tipoProducto-bien'
              label={TiposDeProductoConstant.__dictionary[TiposDeProductoConstant.BIEN].nombre}
              value={TiposDeProductoConstant.__dictionary[TiposDeProductoConstant.BIEN].id}
            />
          )}
        </Field>
      </Col>
      <Col md={3} xl={2}>
        <Field name='tipoProducto'>
          {({ field }) => (
            <Form.Radio
              {...field}
              onChange={onChange}
              disabled={fIsSubmitting}
              checked={iValue === TiposDeProductoConstant.SERVICIO}
              id='radio-tipoProducto-servicio'
              label={TiposDeProductoConstant.__dictionary[TiposDeProductoConstant.SERVICIO].nombre}
              value={TiposDeProductoConstant.__dictionary[TiposDeProductoConstant.SERVICIO].id}
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoDeProductosFormGroup)
